export const hashtagOptions = [
    { value: -1, label: 'All' },
    { value: 1, label: 'Exclude #' }
]

export const carrouselOptions = [
    { value: 1, label: 'Carousels Only' },
    { value: 0, label: 'All' },
    { value: -1, label: 'Exclude Carousels' }
]

export const plateformOptions = [
    { value: 1, label: 'Twitter Only' },
    { value: 0, label: 'All' },
    { value: -1, label: 'Linkedin Only' }
]

export const lastInputDateOptions = [
    {
        value: '0',
        label: 'Any'
    },
    {
        value: '90',
        label: 'Last 90 days'
    },
    {
        value: '180',
        label: 'Last 180 days'
    },
    {
        value: '365',
        label: 'Last 12 months'
    }
]